import { TableColumn } from "../table/TableColumn";

const DeviceEventActionColumns : TableColumn[] = [
    {
        heading:"Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        //sortByName: "setting.sNameOriginal",
        //sortDirection: "asc",
        active: true,
        translationKey: "name"
    },
    {
        heading: "Type",
        accessor: "type",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "type"
    },
    {
        heading: "Device",
        accessor: "device",
        isNumeric: false,
        id: 2,
        active: true,
        translationKey: "device"
    }
];

export default DeviceEventActionColumns;
